export default __webpack_public_path__ + "static/media/au_buxt.df79da82.jpg";